import {BaseDomainModel} from "../../../infrastructure/models/base-domain-model";
import {FormationPositionApiModel} from "./formation-position.api-model";

export class FormationPositionDomainModel extends BaseDomainModel {
  apiModel: FormationPositionApiModel;

  get name(): String {
    return this.apiModel.name;
  }

  get shortName(): String {
    return this.apiModel.shortName;
  }

  get order(): Number {
    return this.apiModel.order;
  }
}
